import { KTMVNOCheckSpace } from 'src/types/api'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body3_r12,
  Noto_desc_r10,
  Noto_subheading_b18,
  Noto_subheading_r18,
} from 'src/styles/fonts/NotoSansKrFonts'
import styled, { css } from 'styled-components'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { Icon } from 'src/assets/svg/Icon'
import React, { useState } from 'react'
import { useModal } from 'src/provider/ModalContextProvider'

const KTMVNOModal = ({
  Title,
  Contents,
  otpRequestHandler,
}: Pick<KTMVNOCheckSpace.Response, 'Contents' | 'Title'> & { otpRequestHandler: () => void }) => {
  const { closeModal } = useModal()
  const [checkBoxValue, setCheckBoxValue] = useState(false)

  const checkBoxValueHandler = () => setCheckBoxValue((prevValue) => !prevValue)

  const onSubmitHandler = () => {
    otpRequestHandler()
    closeModal?.()
  }
  const onCancelHandler = () => closeModal?.()

  return (
    <Container $option="flex_column" $row_gap="16px">
      <Container $option="flex_column">
        <Container $option="flex_row" $style={S.KTMVNOModalXIconWrap}>
          <Icon.GrayCircleX onClickFn={onCancelHandler} size="24" />
        </Container>
        <Container $option="flex_column" $row_gap="6px">
          <Typography $fontStyle={Noto_subheading_r18}>
            KT MVNO(알뜰폰) 추가
            <br /> 약관 동의가 필요합니다.
          </Typography>
          <Typography $fontStyle={Noto_subheading_b18}>아래 약관 확인 후 동의해주세요.</Typography>
        </Container>
      </Container>
      <Container $option="flex_row" $style={S.KTMVNOModalContentsWrap}>
        <Container $option="flex_column" $style={S.KTMVNOModalLeftContents} $row_gap="6px">
          <Typography $fontStyle={Noto_body3_r12}>{Title}</Typography>
          <S.KTMVNOCheckLabel onClick={checkBoxValueHandler}>
            <S.KTMVNOHiddenCheckbox />
            <S.CustomCheckbox $active={checkBoxValue}>
              <Icon.Check />
            </S.CustomCheckbox>
          </S.KTMVNOCheckLabel>
        </Container>
        <Container $option="flex_column" $style={S.KTMVNOModalRightContents}>
          <Typography
            // as={ReactLenis}
            $fontStyle={Noto_desc_r10}
            dangerouslySetInnerHTML={{ __html: Contents as string }}
          />
        </Container>
      </Container>
      <Button
        option={ButtonOption3('active')}
        disabled={!checkBoxValue}
        onClickFn={onSubmitHandler}
      >
        동의 및 인증번호 받기
      </Button>
    </Container>
  )
}
export default KTMVNOModal

const S = {
  KTMVNOModalContentsWrap: css`
    border-radius: 10px;
    border: 1px solid var(--black-10);
    height: 136px;
  `,
  KTMVNOModalXIconWrap: css`
    justify-content: right;
  `,
  KTMVNOModalRightContents: css`
    width: calc(100% - 109px);
    background-color: #f9f9f9;
    border-radius: 0 10px 10px 0;
    padding: 12px;
    overflow-y: auto;
  `,
  KTMVNOModalLeftContents: css`
    width: 109px;
    border-radius: 10px 0 0 10px;
    padding: 0 20px;
    align-items: center;
    justify-content: center;
  `,
  KTMVNOCheckLabel: styled.label`
    width: 26px;
    height: 26px;
    display: flex;
    cursor: pointer;
  `,
  KTMVNOHiddenCheckbox: styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 26px;
    width: 26px;
    z-index: 1;
  `,
  CustomCheckbox: styled.div<{ $active: boolean }>`
    display: flex;
    height: 26px;
    width: 26px;
    min-width: 26px;
    background-color: ${(props) => (props.$active ? 'var(--brand-50)' : 'white')};
    border-radius: 6px;
    flex-direction: column;
    justify-content: center;
    position: relative;
    outline: ${(props) => (props.$active ? 'unset' : `1px solid var(--black-20)`)};

    > svg {
      margin: 0 auto;
    }
  `,
}
